import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { CrescentBrand } from '../CrescentBrand';
import './NewHeader.css';

export default function NewHeader() {
  const [open, setOpen] = useState(false);
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location]);
  useEffect(() => {
    const close = e => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);
  const links = [['/', 'Home', 'home'], ['/#how-it-works', 'How It Works', 'how-it-works'], ['/#pricing', 'Pricing', 'pricing']];
  return <header className="crescent-public-header" data-testid="main-header">
    <div className="crescent-public-header-inner">
      <CrescentBrand testId="public-advisory-home" />
      <nav className="crescent-public-nav" aria-label="Main navigation" data-testid="desktop-nav">
        {links.map(([to, text, id]) => <Link key={id} to={to} data-testid={`public-nav-${id}`}>{text}</Link>)}
        {!loading && <Link className="crescent-header-cta" to={isAuthenticated ? '/intelligence' : '/intelligence/auth'} data-testid={isAuthenticated ? 'header-dashboard-btn' : 'header-login-btn'}>{isAuthenticated ? 'Open Crescent Intelligence' : 'Login'}<ArrowUpRight size={16} /></Link>}
      </nav>
      <button className="crescent-mobile-menu-button" onClick={() => setOpen(!open)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-testid="mobile-menu-btn">{open ? <X size={22} /> : <Menu size={22} />}</button>
    </div>
    {open && <nav className="crescent-public-mobile-nav" aria-label="Mobile navigation" data-testid="mobile-nav">
      {links.map(([to, text, id]) => <Link key={id} to={to} onClick={() => setOpen(false)} data-testid={`mobile-public-nav-${id}`}>{text}</Link>)}
      {!loading && <Link to={isAuthenticated ? '/intelligence' : '/intelligence/auth'} onClick={() => setOpen(false)} data-testid="mobile-public-open-intelligence">{isAuthenticated ? 'Open Crescent Intelligence' : 'Login'}<ArrowUpRight size={16} /></Link>}
    </nav>}
  </header>;
}